<template>
  <div class="service-content">
    <div class="title">他们都选择了通文服务</div>
    <div class="service-row">
      <div
        class="service-flex"
        v-for="(item, index) in coopList"
        :key="index"
        @click="openLink(item)"
      >
        <img :src="item.cover" alt="" class="image" />
        <div class="flex-title">{{ item.articleName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticlePage } from '@/api/home/home.js'
export default {
  data() {
    return {
      coopList: []
    }
  },
  created() {
    this.getCoopPage(106)
  },
  methods: {
    getCoopPage(categoryCode) {
      getArticlePage({
        page: 1,
        limit: 1000,
        categoryCode: categoryCode
      }).then((res) => {
        if (!res.data) return
        this.coopList = res.data.list
      })
    },
    //   跳转
    openLink(item) {
      if (item.articleUrl) {
        window.open(item.articleUrl)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.service-content {
  display: flex;
  flex-direction: column;
  margin: 64px auto;
  width: 1472px;

  .service-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 34px;
    padding: 24px 0;
    box-sizing: border-box;
    gap: 48px;
    .service-flex {
      display: flex;
      flex-direction: column;
      width: 299px;
      height: 168px;
      padding: 14px 24px 16px;
      background: #fff;
      box-shadow: -1px 4px 27.9px 0 rgba(111, 108, 108, 0.05);
      cursor: pointer;
      .flex-title {
        width: 251px;
        height: 34px;
        line-height: 34px;
        color: #333;
        font-size: 20px;
        font-weight: 500;
        margin-top: 16px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .image {
        width: 236px;
        height: 88px;
        margin: 0 auto;
        object-fit: contain;
      }
    }
  }
  .title {
    color: #111;
    font-size: 40px;
    font-weight: 600;
    line-height: 60px;
    margin-top: 16px;
    text-align: center;
  }
  .title-btn {
    border-radius: 9999px;
    border: 0 solid #e5e7eb;
    background: rgba(27, 86, 169, 0.1);
    width: 88px;
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    color: #1b56a9;
    font-size: 14px;
    font-weight: 500;
    margin: 0 auto;
  }
}

// 手机端css
.mobile-content {
  .service-content {
    margin: 32px auto;
    width: 345px;
    .service-row {
      margin-top: 20px;
      padding: 0;
      gap: 24px;
      width: 100%;
      .service-flex {
        width: calc(100% / 2 - 13px);
        height: auto;
        padding: 10px 12px 8px;
        .flex-title {
          width: 100%;
          line-height: 25px;
          height: 25px;
          font-size: 14px;
        }
        .image {
          width: 100%;
          height: 54px;
        }
      }
    }
    .title {
      font-size: 24px;
      line-height: 35px;
      height: auto;
    }
  }
}
</style>
